<template>
  <div class="page4-main">
    <div class="filter-main">
      筛选条件：
      <div class="filter-item">
        <label>作品数量：</label>
        <el-select v-model="worksCount" placeholder="请选择" clearable @change="handleWorksCountSearch">
          <el-option v-for="item in worksCountList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <div class="search_total">
      <p class="total">
        <span>{{ listTotal }}</span
        >条期刊数据
      </p>
    </div>
    <subject-list-skeleton v-if="loading" variant="journal" />
    <ul v-else class="right-item">
      <li class="flex" v-for="(item, index) in listData" :key="index">
        <span class="index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
        <div class="img" @click="toDetail(item.sid)">
          <img :src="item.cover ? imgUrl + item.cover : defaultImg" />
        </div>
        <div class="right-info">
          <p v-if="item.name" @click="toDetail(item.sid)">
            <span v-safe-html="item.name"></span>
          </p>
          <p v-if="item.issn">ISSN：<span v-safe-html="item.issn"></span></p>
          <p v-if="item.aliasName">其他刊名：<span v-safe-html="item.aliasName"></span></p>
          <p v-if="item.publisherName">出版社：<span v-safe-html="item.publisherName"></span></p>
        </div>
      </li>
    </ul>
    <div class="noData" v-if="total <= 0 && !loading">
      <img src="../../assets/images/noData.png" />
    </div>
    <el-pagination v-if="!loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
  </div>
</template>

<script>
import baseUrlConfig from "../../api/baseurl.js";
import SubjectListSkeleton from "@/components/SubjectListSkeleton.vue";

export default {
  components: { SubjectListSkeleton },
  data() {
    return {
      loading: true,
      pageSize: 10,
      pageNo: 1,
      total: 0,
      listTotal: 0,
      listData: [],
      keyWords: "",
      imgUrl: baseUrlConfig.fileUrl || "",
      defaultImg: require("../../assets/images/default.png"),
      worksCountList: [
        {
          name: "作品数量大于100",
          value: "100-",
        },
        {
          name: "作品数量50-100",
          value: "50-100",
        },
        {
          name: "作品数量30-50",
          value: "30-50",
        },
        {
          name: "作品数量10-30",
          value: "10-30",
        },
        {
          name: "作品数量小于10",
          value: "-10",
        },
      ],
      worksCount: "",
      worksCountStart: "",
      worksCountEnd: "",
    };
  },
  props: {
    parentData: {
      type: String,
      default: "",
    },
    parentConceptId: {
      type: String,
      default: "",
    },
  },
  watch: {
    parentData(val) {
      this.pageNo = 1;
      this.keyWords = val;
      this.getListData();
    },
    deep: true,
  },
  mounted() {
    this.imgUrl = baseUrlConfig.fileUrl || "";
    this.keyWords = this.parentData;
    if (this.keyWords) {
      this.getListData();
    }
  },
  methods: {
    handleWorksCountSearch(val) {
      this.worksCount = val;
      let _val = this.worksCount.split("-");
      this.worksCountStart = _val[0] ? _val[0] : "";
      this.worksCountEnd = _val[1] ? _val[1] : "";
      this.pageNo = 1;
      this.getListData();
    },
    clearSearch() {
      this.worksCount = "";
      this.worksCountStart = "";
      this.worksCountEnd = "";
      this.pageNo = 1;

      this.getListData();
    },
    getListData() {
      let postBody = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        keyWords: this.keyWords,
        conceptId: this.parentConceptId,
        paperCountStart: this.worksCountStart,
        paperCountEnd: this.worksCountEnd,
      };
      this.loading = true;
      this.$http({
        url: "api/v1/concept/journal/list",
        method: "post",
        data: postBody,
      }).then(res => {
        this.loading = false;
        this.listData = res.rows;
        this.total = res.total > 10000 ? 10000 : res.total;
        this.listTotal = res.total;
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getListData();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getListData();
    },
    toDetail(sid) {
      const { href } = this.$router.resolve({
        path: `/homeDetail`,
        query: { sid: sid },
      });
      window.open(href, "_self");

      // this.$router.push({ path: "homeDetail", query: { id: id } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/public.scss";
.page4-main {
  .search_total {
    display: flex;
    align-items: center;
    .total {
      color: #86909c;
      span {
        color: #ff0000;
        margin-right: 5px;
      }
    }
    .search {
      margin-left: auto;
      width: 400px;
      position: relative;
      display: flex;
      align-items: center;
      ::v-deep .el-input__inner {
        border-radius: 0;
      }
      > span {
        background: #2d8cf0;
        height: 40px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  .right-item {
    li {
      padding: 20px 0;
      border-bottom: 1px dashed #eeeeee;
      .index {
        width: 50px;
      }
      .img {
        width: 160px;
        height: 160px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border: 1px solid #eeeeee;
        cursor: pointer;
        margin-right: 20px;
        cursor: pointer;
        img {
          max-width: 158px;
          max-height: 158px;
        }
      }
      .right-info {
        color: #666666;
        flex: 1;
        min-width: 0;
        position: relative;
        p {
          line-height: 25px;
          &:nth-of-type(1) {
            color: #333;
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 10px;
            cursor: pointer;
          }
          img {
            margin-left: 10px;
            height: 22px;
            vertical-align: -6px;
          }
        }
        .yinzi {
          position: absolute;
          bottom: 0;
          left: 0;
          font-size: 14px;
          span {
            color: #45c1c3;
          }
        }
      }
      &:hover {
        .right-info {
          p {
            &:nth-of-type(1) {
              background-image: linear-gradient(to right, #006eb3, #2d8cf0);
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              // color: #2d8cf0;
            }
          }
        }
      }
    }
  }
}
</style>
